/**
 * Utilidades de dinero. Todos los montos se manejan como enteros en centavos
 * para evitar errores de punto flotante.
 */
export const MONEDAS = ['MXN', 'USD'] as const;
export type Moneda = (typeof MONEDAS)[number];

/** Redondeo half-up (lejos de cero) tolerante a errores de representación binaria. */
export function redondear(valor: number): number {
  const limpio = Number(Math.abs(valor).toFixed(6));
  return Math.sign(valor) * Math.round(limpio) || 0;
}

export function aCentavos(pesos: number): number {
  return redondear(pesos * 100);
}

export function aplicarPorcentaje(centavos: number, porcentaje: number): number {
  return redondear((centavos * porcentaje) / 100);
}

/** Convierte a MXN. `tipoCambio` = pesos por 1 USD (hasta 4 decimales). */
export function convertirAMXN(centavos: number, moneda: Moneda, tipoCambio: number): number {
  return moneda === 'MXN' ? centavos : redondear(centavos * tipoCambio);
}

/** Reparte `total` en `partes` enteras; el residuo va a las primeras partes. */
export function repartir(total: number, partes: number): number[] {
  if (!Number.isInteger(partes) || partes <= 0) {
    throw new RangeError('El número de partes debe ser un entero positivo');
  }
  const base = Math.floor(total / partes);
  const residuo = total - base * partes;
  return Array.from({ length: partes }, (_, i) => base + (i < residuo ? 1 : 0));
}

const formatoNumero = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatearMoneda(centavos: number, moneda: Moneda = 'MXN'): string {
  const signo = centavos < 0 ? '-' : '';
  const prefijo = moneda === 'USD' ? 'US$' : '$';
  return `${signo}${prefijo}${formatoNumero.format(Math.abs(centavos) / 100)}`;
}
